import { ImpactCategoryId } from '@upright/common/model/input/impacts/impact-categories';
import { Valence } from '@upright/common/model/types';
import { getEuObjectivesForImpactCategory } from '../common/taxonomy-mapping';
import { useTaxonomyLensContext } from '../common/use-taxonomy-lens-context';
import { TaxonomyIndicatorBox } from './taxonomy-kpi-box';

interface Props {
  impact: ImpactCategoryId;
  valence: Valence;
}

export function TaxonomyIndicatorBoxes(props: Props) {
  const context = useTaxonomyLensContext();
  if (!context?.data.taxonomyKpis || props.valence !== Valence.POSITIVE) {
    return <></>;
  }

  const objectives = getEuObjectivesForImpactCategory(props.impact);
  const boxes = objectives.map((objective, index) => {
    return (
      <TaxonomyIndicatorBox
        key={objective}
        objective={objective}
        impact={props.impact}
        index={index}
        valence={Valence.POSITIVE}
      />
    );
  });
  return <>{boxes}</>;
}
